<template>
<m-pageframe
    title="Reset Demo Account"
>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.demo_cell_phone="{ item }">
            {{$rc.pretty(item.demo_cell_phone,'endpoint_no_parens')}}
        </template>

        <template v-slot:item.endpoint_primary_user="{ item }">
            {{$rc.pretty(item.endpoint_primary_user,'endpoint_no_parens')}}
        </template>

        <template v-slot:item.endpoint_bot="{ item }">
            {{$rc.pretty(item.endpoint_bot,'endpoint_no_parens')}}
        </template>

        <template v-slot:item.primary_user_label="{ item }">
            <a 
                v-if="item.primary_user_label"
                style="text-decoration: underline"
                v-on:click="onClickSignInAs(item)"
            >
                {{item.primary_user_label}}
            </a>
        </template>

        <template v-slot:item.action="{ item }">

            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickResetDemo(item)"
                >
                    <v-list-item-title>Reset Demo...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 

        </template>
    
    </v-data-table>

    <m-admin-mutlidemo-reset-dialog
        ref="reset-dialog"
        v-on:reset="doUpdate"
    />


</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Environment', value: 'environment'},
                { text: 'Name', value: 'internal_stable_label'},
                { text: 'Owner', value: 'redchirp_owner_label'},
                { text: 'Industry', value: 'organization_industry'},
                { text: 'Primary User', value: 'primary_user_label'},
                { text: 'Demo Device', value: 'demo_cell_phone'},
                { text: 'RedChirp (Primary)', value: 'endpoint_primary_user'},
                { text: 'RedChirp (Bot)', value: 'endpoint_bot'},
                { text: 'Action', value: 'action'},
            ],
        };
    },

    mounted () {
        this.doUpdate();
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/demo/organizations',
            
                'params' : {
                        'full_text': this.full_text,
                        'environment': this.$rc.getEnvironment() == 'dev' ? null : 'production',
                    },
            
                'on_success': (data) => {
                        this.results = data.results;  
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },
        

        onClickResetDemo(item)
        {
            this.$refs['reset-dialog'].showDialog(item);
        },

        onClickSignInAs(item)
        {
            this.$rc.newSignInAs(
                {
                    'organization_id': item.organization_id,
                    'employee_id': item.primary_user_employee_id,
                }
            );
        },
    },
    
}
</script>

<style lang="scss" scoped>
</style>